import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function AboutSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const stats = [{
    number: '15+',
    label: 'Years of Excellence'
  }, {
    number: '50+',
    label: 'World-Class Instructors'
  }, {
    number: '12K',
    label: 'Students Transformed'
  }, {
    number: '8',
    label: 'Dance Disciplines'
  }];
  return <section ref={ref} className="relative w-full bg-black py-32 overflow-hidden" data-id="element-4">
      {/* Diagonal spotlight */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 800px 600px at 80% 30%, rgba(255,255,255,0.04) 0%, transparent 60%)'
    }} data-id="element-5" />

      <div className="max-w-7xl mx-auto px-6" data-id="element-6">
        {/* Section header with geometric accent */}
        <div className="mb-24" data-id="element-7">
          <motion.div initial={{
          width: 0
        }} animate={isInView ? {
          width: 120
        } : {}} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="h-px bg-white/40 mb-8" data-id="element-8" />
          <motion.span initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-white/40 text-xs tracking-[0.5em] uppercase" data-id="element-9">
            Our Philosophy
          </motion.span>
        </div>

        {/* Main content grid */}
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-10">
          {/* Left: Image with dramatic treatment */}
          <motion.div initial={{
          opacity: 0,
          x: -60
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 1,
          delay: 0.3,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} className="relative" data-id="element-11">
            <div className="relative aspect-[3/4] overflow-hidden" data-id="element-12">
              <img src="https://images.unsplash.com/photo-1547153760-18fc86324498?w=800&q=80" alt="Dancer in dramatic pose" className="w-full h-full object-cover" style={{
              filter: 'contrast(1.5) brightness(0.5) grayscale(1)'
            }} data-id="element-13" />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent" data-id="element-14" />
            </div>
            {/* Geometric frame accent */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-white/20 -z-10" data-id="element-15" />
          </motion.div>

          {/* Right: Text content */}
          <div data-id="element-16">
            <motion.h2 initial={{
            opacity: 0,
            y: 40
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.8,
            delay: 0.4
          }} className="font-display text-5xl md:text-7xl font-bold leading-[0.9] mb-8" data-id="element-17">
              Dance Is
              <span className="block text-white/20 italic" data-id="element-18">Theater</span>
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="text-white/60 text-lg leading-relaxed mb-8" data-id="element-19">
              Every movement tells a story. Every step commands attention. At
              our studio, we don't just teach dance—we craft performers who own
              the stage from the moment they enter.
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.8,
            delay: 0.6
          }} className="text-white/40 text-base leading-relaxed mb-12" data-id="element-20">
              Our methodology blends classical technique with contemporary
              expression, creating dancers who are technically precise yet
              emotionally compelling. This is where discipline meets artistry.
            </motion.p>

            {/* Geometric divider */}
            <motion.div initial={{
            scaleX: 0
          }} animate={isInView ? {
            scaleX: 1
          } : {}} transition={{
            duration: 0.8,
            delay: 0.7
          }} className="h-px bg-white/20 mb-12 origin-left" data-id="element-21" />

            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-8" data-id="element-22">
              {stats.map((stat, index) => <motion.div key={stat.label} initial={{
              opacity: 0,
              y: 20
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.6,
              delay: 0.8 + index * 0.1
            }} data-id="element-23">
                  <span className="font-display text-4xl md:text-5xl font-bold block mb-2" data-id="element-24">
                    {stat.number}
                  </span>
                  <span className="text-white/40 text-sm tracking-wider uppercase" data-id="element-25">
                    {stat.label}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-26">
        <div className="geometric-line w-full" data-id="element-27" />
      </div>
    </section>;
}